import { useRef } from "react";

import * as S from "./LandingPageBreakthroughOrganism.style";
import { useRouter } from "next/router";
import { logCourseTitle, sendLog } from "@/businessLogics/_common/logging";

export let breakthroughRef;

const LandingPageBreakthroughOrganism = ({
  title,
  desc,
  course,
}: {
  title: JSX.Element;
  desc: JSX.Element;
  course: string;
}) => {
  breakthroughRef = useRef();
  const router = useRouter();
  const videoName = router.asPath.includes("pm")
    ? "landing_trailer_renewal"
    : "landing_trailer_renewal_mkt";

  function clickVideo() {
    sendLog(`sw_${logCourseTitle[course]}_video_click`, { explain: "sw_info" });
  }

  return (
    <S.Wrapper ref={breakthroughRef}>
      <S.Title>{title}</S.Title>
      <S.Content>
        <S.DesktopVideo
          onClick={clickVideo}
          autoPlay
          muted
          loop
          playsInline
          controls
          controlsList={"nodownload"}
        >
          <source
            src={`${process.env.CDN_BASE_URL}/swcamp/${videoName}.mp4`}
            type="video/mp4"
          />
        </S.DesktopVideo>
        <S.Text>
          <S.MobileVideoWrapper>
            <S.MobileVideo
              onClick={clickVideo}
              autoPlay
              muted
              loop
              playsInline
              controls
              controlsList={"nodownload"}
            >
              <source
                src={`${process.env.CDN_BASE_URL}/swcamp/${videoName}.mp4`}
                type="video/mp4"
              />
            </S.MobileVideo>
          </S.MobileVideoWrapper>
          <S.Desc>{desc}</S.Desc>
        </S.Text>
      </S.Content>
    </S.Wrapper>
  );
};

export default LandingPageBreakthroughOrganism;
